import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wzc-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainMenuComponent {}
